import { Table, Checkbox } from "antd";
import { useEffect, useState } from "react";
/**
 *
 * @param {Array} data 表格数据
 * @param {Object} params 表格其他参数
 * @param {Boolean} canCheck 能否被选择
 * @param {Function} onChange 表格行被筛选时的方法
 * @param {Boolean} isAfterSale 是否是售后商品表格 默认false
 * @returns
 */
const ProductTable = (props) => {
  const {
    data,
    params = {},
    canCheck,
    onChange = () => {},
    isAfterSale,
  } = props;
  const [selection, setSelection] = useState({});
  const columns = [
    {
      title: "商品编码",
      dataIndex: "skuNo",
      key: "skuNo",
      align: "center",
    },
    {
      title: "条码",
      dataIndex: "barcode",
      key: "barcode",
      align: "center",
    },
    {
      title: "商品名称",
      dataIndex: "productName",
      key: "productName",
      align: "center",
    },
    {
      title: "原价（元）",
      dataIndex: "salePrice",
      key: "salePrice",
      align: "center",
    },
    {
      title: "促销价（元）",
      dataIndex: "salePrice",
      key: "salePrice",
      align: "center",
    },
    {
      title: "规格",
      dataIndex: "spec",
      key: "spec",
      align: "center",
    },
    {
      title: "包装单位",
      dataIndex: "unit",
      key: "unit",
      align: "center",
    },
    {
      title: "计价方式",
      dataIndex: "saleWay",
      key: "saleWay",
      align: "center",
    },
    {
      title: "数量",
      dataIndex: "count",
      key: "count",
      align: "center",
    },
    {
      title: "总价（元）",
      dataIndex: "saleAmount",
      key: "saleAmount",
      align: "center",
      render: (text, record) =>
        text || record.saleAmount
          ? "￥" + (isAfterSale ? record.saleAmount : text)
          : "",
    },
  ];
  useEffect(() => {
    canCheck
      ? setSelection({
          rowSelection: {
            type: "checkbox",
            onChange,
            getCheckboxProps: (record) => {
              return { disabled: !record.canAftersale };
            },
          },
        })
      : setSelection({});
  }, [canCheck, onChange]);
  return (
    <Table
      size="middle"
      bordered
      columns={columns}
      dataSource={data}
      pagination={false}
      rowKey="id"
      {...selection}
      {...params}
    />
  );
};
export default ProductTable;
